import { clsx } from 'clsx';
import type { CryptoCoin } from '../../../utils/payments/mockCrypto';

type CoinToggleProps = {
  value: CryptoCoin;
  onChange: (next: CryptoCoin) => void;
};

const COINS: { id: CryptoCoin; label: string }[] = [
  { id: 'eth', label: 'ETH' },
  { id: 'usdc', label: 'USDC' },
];

export function CoinToggle({ value, onChange }: CoinToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Moeda"
      className="inline-flex rounded-full border border-gold/30 bg-night/40 p-1"
    >
      {COINS.map((c) => {
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(c.id)}
            className={clsx(
              'rounded-full px-4 py-1.5 font-mono text-xs uppercase tracking-stamp transition-colors duration-fast',
              'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold',
              active
                ? 'bg-gold/15 text-gold shadow-goldSoft'
                : 'text-champagne/60 hover:text-champagne',
            )}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
